import React from 'react';
import {
  FormFieldRequiredSource,
  isFormFieldStrictlyRequired,
} from 'views/EMR/components/FillableForm/utils/fieldPositioning';

type Props = FormFieldRequiredSource & {
  name?: string | null;
  className?: string;
};

export default function FormFieldInlineLabel({
  name,
  isRequired,
  type,
  className,
}: Props) {
  const required = isFormFieldStrictlyRequired({ isRequired, type });

  return (
    <span className={className ?? 'font-semibold'}>
      {name}
      {!required && (
        <span className="text-[11px] italic font-normal text-gray-400 ml-1">(Optional)</span>
      )}
    </span>
  );
}
